interface IExcelColumn {
  /**
   * Human-readable label.
   */
  label: string; // "Depth"
}

type ExcelColumn = 
    'latitude'
  | 'longitude'
  | 'depth'
  | 'u'
  | 'v'
  | 'daily_poc'
  | 'yearly_poc'
  | 'oxygen'
  | 'ammonia'
  | 'chlorophyll'
  | 'pathogen'
  | 'poc_in_sediment'
  | 'pom_in_sediment'
  | 'bacteria_sediment'
  | 'oxygen_in_sediment'
  | 'sulphate_in_sediment'
  | 'iron_hydroxide_in_sediment'
  | 'total_sulphide_in_sediment'
  | 'iron_in_sediment'
  | 'iron_sulphide_in_sediment'
  | 'therapeutants';

const ExcelColumnDictionary: {[key: string]: IExcelColumn} = {
  "latitude":  { label: "Latitude" },
  "longitude": { label: "Longitude" },
  "depth": { label: "Depth" },
  "u": { label: "Eastward velocity" },
  "v": { label: "Northward velocity" },
  "daily_poc": { label: "Daily POC" },
  "yearly_poc": { label: "Yearly POC" },
  "oxygen": { label: "Dissolved oxygen" },
  "ammonia": { label: "NH4 concentration" },
  "chlorophyll": { label: "Chlorophyll" },
  "pathogen": { label: "Pathogen" },
  "poc_in_sediment": { label: "POC in sediment" },
  "pom_in_sediment": { label: "POM in sediment" },
  "bacteria_sediment": { label: "Bacteria in sediment" },
  "oxygen_in_sediment": { label: "Oxygen in sediment" },
  "sulphate_in_sediment": { label: "Sulphate in sediment" },
  "iron_hydroxide_in_sediment": { label: "Iron hydroxide in sediment" },
  "total_sulphide_in_sediment": { label: "Total sulphide in sediment" },
  "iron_in_sediment": { label: "Iron in sediment" },
  "iron_sulphide_in_sediment": { label: "Iron sulphide in sediment" },
  "therapeutants": { label: "Therapeutants" },
}

export { IExcelColumn, ExcelColumnDictionary, ExcelColumn }

